<div class="mb-3">
  <textarea [formControl]="formControl" class="form-control" rows="3" #formTextArea></textarea>
</div>
